import React from 'react';
import { observer } from 'mobx-react-lite';
import useStores from '../../../../../../../../hooks/useStores';
import styles from '../index.module.scss';
import classNames from 'classnames';
import { measurementOptionsWithoutUnit } from '../../../../../../../MeasurementsAction/MeasurementOptions';
import { RadioGroup, FormLabel, FormControlLabel, Radio } from '@mui/material';
import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../hooks/useIntakeBlockToggle';

function SelectMeasurementUnitField() {
  const { measurementsStore } = useStores();
  const { isOn } = useIntakeBlockToggle();

  const onChange = (unit: number) => {
    measurementsStore.save(unit);
  };

  if (!isOn(intakeBlocksEnum.physical)) {
    return null;
  }

  return (
    <div>
      <RadioGroup
        value={measurementsStore.unitsMapping}
        className={classNames(
          styles.radioFieldWrapper,
          styles.rowRadioWrapper,
          'justify-between flex-nowrap',
        )}
      >
        <FormLabel className={styles.formLabel}>System</FormLabel>
        <div className={styles.radioLabelsWrapper}>
          {measurementOptionsWithoutUnit?.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              className={styles.radioLabel}
              control={
                <Radio
                  value={value}
                  onChange={({ target: { value } }) => onChange(Number(value))}
                  classes={{
                    root: styles.radio,
                    checked: styles.checked,
                  }}
                />
              }
              label={label}
            />
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
export default observer(SelectMeasurementUnitField);
